import { SearchInterface } from "@amzn/ask-legal-domain";
import { Box, SpaceBetween } from "@amzn/awsui-components-react";
import { QueryResultItem }  from "@aws-sdk/client-kendra";
import * as React from "react";
import { AppContext } from "../../setup/context";
import { callApi } from "../../utils/api-call";
import { useInstanceDataContext } from "../../contexts/InstanceDataContext";
import { useCrossInstanceSearch } from "../../hooks/use-cross-instance-search";
import { UIModel } from "../../model/ui-model";
import { getInstanceIdFromResult, isStandardResult } from "../../utils/search-utils";
import { SearchResultItem } from "./search-components/SearchResultItem";
import "../../styles/component/layout/SearchResultPageLayout.scss";

export const SearchResultPanelV2 = (props: {
    instanceId?: string;
    results: SearchInterface.SearchQueryResponse;
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
}) => {
    const context = React.useContext(AppContext);
    const isCrossInstanceSearchEnabled = useCrossInstanceSearch();
    const { loadInstance, instanceCache } = useInstanceDataContext();

    // Fire-and-forget: click feedback is best effort and its result is not shown
    const submitClickFeedback = (resultId: string) => {
        callApi(
            context.getSearchAPI().feedback,
            SearchInterface.SubmitFeedbackInput.create({
                instanceId: props.instanceId!,
                queryId: props.results.result.QueryId!,
                clickFeedbackItems: [{
                    ClickTime: new Date(),
                    ResultId: resultId
                }]
            })
        );
    };

    React.useEffect(() => {
        if (isCrossInstanceSearchEnabled || !props.instanceId) {
            const instanceIds = props.results.result.ResultItems
                .filter(isStandardResult)
                .map(getInstanceIdFromResult)
                .filter(Boolean) as string[];
            const uniqueInstanceIds = [...new Set(instanceIds)];
            const missingIds = uniqueInstanceIds.filter(id => !instanceCache[id]);
            missingIds.forEach(instanceId => {
                loadInstance(instanceId).catch(console.error);
            });
        }
    }, [props.results, isCrossInstanceSearchEnabled, props.instanceId, loadInstance, instanceCache]);

    const otherResults = props.results.result.ResultItems.filter(isStandardResult);

    return (
        <SpaceBetween direction="vertical" size="l">
            { props.results.result.TotalNumberOfResults === 0 && (
                <div>No relevant resources found</div>
            )}
            { otherResults.length > 0 && (
                <div>
                    <Box variant="small">
                        Displaying {otherResults.length} of {
                        props.results.result.TotalNumberOfResults > 100 ?
                        100 : props.results.result.TotalNumberOfResults
                    } results
                    </Box>
                    <br/>
                    <br/>
                    <SpaceBetween direction="vertical" size="l">
                        {otherResults.map((r: QueryResultItem) => (
                            <SearchResultItem
                                key={r.Id}
                                item={r}
                                currentInstanceId={props.instanceId}
                                submitClickFeedback={submitClickFeedback}
                            />
                        ))}
                    </SpaceBetween>
                </div>
            )}
        </SpaceBetween>
    );
};
